import { createContext, useContext } from 'react';
import type { ModalStackContextValue } from './modal-stack-types';

export const ModalStackContext = createContext<ModalStackContextValue | null>(null);

export function useModalStackContext(): ModalStackContextValue {
  const context = useContext(ModalStackContext);
  if (!context) {
    throw new Error('ModalStackProvider not mounted');
  }
  return context;
}
